module.exports = __webpack_public_path__ + "img/damage-small.17c7c9fc.png";